import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Card, Button, Grid, Typography, Divider, Avatar, IconButton, Snackbar } from "@material-ui/core";
import { inject, observer } from "mobx-react";

import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import "./ManagedActCard.css";
import ConfirmationModal from "../modal/ConfirmationModal";
import image from "../../helper/image";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import EventIcon from "@material-ui/icons/Event";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Tooltip from "@material-ui/core/Tooltip";

import { ImageLazy } from "../image/ImageCool";
import blankBackground from "../../img/hero2.jpg";
import { ProfileType } from "../../types/enum";

@inject("agentMusicianStore", "rosterStore", "profileStore", "agentActStore")
@withRouter
@observer
class ManagedActCard extends Component {
    state = {
        acceptConfirmationState: false,
        declineConfirmationState: false,
        quitConfirmationState: false,
        duplicateConfirmationState: false,
        openDuplicateSnackbar: false
    };

    handleOpenAcceptRequest = () => {
        this.setState({
            ...this.state,
            acceptConfirmationState: true
        });
    };

    handleOpenQuitAct = () => {
        this.setState({
            ...this.state,
            quitConfirmationState: true
        });
    };

    handleOpenDeclineRequest = () => {
        this.setState({
            ...this.state,
            declineConfirmationState: true
        });
    };

    handleCloseConfirmation = () => {
        this.setState({
            ...this.state,
            acceptConfirmationState: false,
            declineConfirmationState: false,
            quitConfirmationState: false,
            duplicateConfirmationState: false
        });
    };

    handleOpenDuplicateRequest = () => {
        this.setState({
            ...this.state,
            duplicateConfirmationState: true
        });
    };

    handleAcceptRequest = () => {
        const { act } = this.props;
        this.props.rosterStore.acceptDeclineRequest(act.id, true).then(response => {
            this.props.profileStore.getUserActList();
            this.handleCloseConfirmation();
        });
    };

    handleDeclineRequest = () => {
        const { act } = this.props;
        this.props.rosterStore.acceptDeclineRequest(act.id, false).then(response => {
            this.props.profileStore.getUserActList();
            this.handleCloseConfirmation();
        });
    };

    handleQuitAct = () => {
        const { act } = this.props;
        this.props.rosterStore.quitRoster(act.id).then(response => {
            this.props.profileStore.getUserActList();
            this.handleCloseConfirmation();
        });
    };

    handleDupicateRequest = () => {
        const { act } = this.props;
        this.props.profileStore.duplicateProfile(act.id).then(response => {
            this.handleCloseConfirmation();
            this.setState({ openDuplicateSnackbar: true});
            setTimeout(
                function () {
                    this.props.history.replace(`/myact/edit/${response.id}`);
                }.bind(this),
                2000
            );
            
        });
    };

    handleSnackbarEditClose = (event, reason) => {
        this.setState({ openDuplicateSnackbar: false });
    };

    handleEdit = () => {
        if(this.props.agentAct) {
            this.props.agentActStore.setIsAgentAct(true);
        }
    }

    render() {
        const { act } = this.props;
        const background = image.getBackgroundImage(act);
        var subheader = this.props.agentMusicianStore.getLineUpCounts(act.lineUpCount)
        var currentProfile = this.props.profileStore.currentProfile
        if(act.vibesName){
            subheader = subheader + " / " + act.vibesName
        }
        if(act.genreName){
            subheader = subheader + " / " + act.genreName
        }
        return (
            <Fragment>
                <Card className="manage-act" raised={false} style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)", backgroundColor: "#3A3B3D" }}>
                    <div
                        className="act-background-image"
                    >
                        <ImageLazy className="act-bg-img" src={background} placeholder={blankBackground} />
                        <ImageLazy className="act-avatar" style={{ borderRadius: '50%', boxShadow: '0 6px 16px rgba(0, 0, 0, 0.35)' }} aria-label={act.actName} src={image.getProfileImage(act)} />
                    </div>
                    <CardContent className="act-details">
                        <Typography variant="headline" component="h2">
                            <Link className="act-profile-link" to={"/profile/" + act.id} target={"_blank"} style={!act.isCompleted ? {fontSize:  "20px", display:"flex", alignItems:"center"} : {}}>
                                {this.props.type === "act" ? act.actName : act.profileName} {!act.isCompleted ? <div style={{fontSize: "12px", marginLeft:"5px", backgroundColor:"#B71C1C", color:"white", padding:"7px", borderRadius:"5px", cursor:"default"}}>draft</div> : null}
                            </Link>
                        </Typography>
                        {this.props.type === "act" && (
                            <Typography gutterBottom variant="caption">
                                {subheader}
                            </Typography>
                        )}
                        <Typography className="act-bio" component="div" dangerouslySetInnerHTML={{ __html: act.bio }} />
                    </CardContent>
                    <Divider />
                    {!this.props.hideActions && (
                        <CardActions className="act-action">
                            {this.props.type === "act" ? (
                                <Fragment>
                                    {act.myAct ? (
                                        <Fragment>
                                            <Button
                                                className="btn-primary"
                                                component={Link}
                                                to={`/myact/edit/${act.id}`}
                                                size="small"
                                                onClick={this.handleEdit}
                                            >
                                                <EditIcon style={{ fontSize: 16, marginRight: 4 }} />
                                                Edit Act
                                            </Button>
                                            <Tooltip title="Calendar">
                                                <IconButton
                                                    className="btn-icon-outline"
                                                    component={Link}
                                                    to={`/calendar/${act.id}/act`}
                                                    size="small"
                                                >
                                                    <EventIcon style={{ fontSize: 18 }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Duplicate">
                                                <IconButton
                                                    className="btn-icon-ghost"
                                                    onClick={this.handleOpenDuplicateRequest}
                                                    size="small"
                                                >
                                                    <FileCopyIcon style={{ fontSize: 18 }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Remove">
                                                <IconButton
                                                    className="btn-icon-danger"
                                                    onClick={this.props.handleRemove}
                                                    size="small"
                                                >
                                                    <DeleteIcon style={{ fontSize: 18 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Fragment>
                                    ) : act.accepted ? currentProfile?.type === ProfileType.Musician.ordinal ? (
                                        <Fragment>
                                            <Button
                                                className="btn-primary"
                                                component={Link}
                                                to={`/calendar/${act.id}/act`}
                                                size="small"
                                            >
                                                <EventIcon style={{ fontSize: 16, marginRight: 4 }} />
                                                Calendar
                                            </Button>
                                            <Tooltip title="Quit Act">
                                                <IconButton
                                                    className="btn-icon-danger"
                                                    onClick={this.handleOpenQuitAct}
                                                    size="small"
                                                >
                                                    <ExitToAppIcon style={{ fontSize: 18 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <Button
                                                className="btn-outline"
                                                component={Link}
                                                to={`/calendar/${act.id}/act`}
                                                size="small"
                                            >
                                                <EventIcon style={{ fontSize: 16, marginRight: 4 }} />
                                                Calendar
                                            </Button>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <Button className="btn-danger" size="small" onClick={this.handleOpenDeclineRequest}>
                                                Decline
                                            </Button>
                                            <Button className="btn-primary" size="small" onClick={this.handleOpenAcceptRequest}>
                                                Accept
                                            </Button>
                                        </Fragment>
                                    )}
                                </Fragment>
                            ) : (
                                <Grid container spacing={8}>
                                    <Grid item md={12} xs={12} sm={12}>
                                        <Button className="btn-outline" size="small">
                                            View
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}
                        </CardActions>
                    )}
                </Card>

                <ConfirmationModal
                    open={this.state.acceptConfirmationState}
                    title="Accept Request"
                    message={`Are you sure you would like to accept the invite to join and be booked by ${act.actName}? `}
                    closeHandler={this.handleCloseConfirmation}
                    confirmationHandler={this.handleAcceptRequest}
                    declineHandler={this.handleCloseConfirmation}
                    confirmationLabel="Accept"
                />

                <ConfirmationModal
                    open={this.state.declineConfirmationState}
                    title="Decline Request"
                    message={`Are you sure to decline ${act.actName}?`}
                    closeHandler={this.handleCloseConfirmation}
                    confirmationHandler={this.handleDeclineRequest}
                    declineHandler={this.handleCloseConfirmation}
                    confirmationLabel="Decline"
                />

                <Dialog
                    open={this.state.quitConfirmationState}
                    onClose={this.handleCloseConfirmation}
                    aria-labelledby="leave-dialog-title"
                    className="dialog-div invitation-dialog"
                    PaperProps={{ style: { borderRadius: '12px', overflow: 'hidden', minWidth: '380px' } }}
                >
                    <div style={{ background: 'linear-gradient(135deg, #FF0C9C 0%, #ff4db8 100%)', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <ExitToAppIcon style={{ color: '#ffffff', fontSize: '24px' }} />
                        <Typography variant="h6" style={{ color: '#ffffff', fontSize: '18px', fontWeight: 500, margin: 0 }}>Leave Act</Typography>
                    </div>
                    <DialogContent style={{ padding: '24px 20px' }}>
                        <DialogContentText style={{ color: '#333', fontSize: '15px', lineHeight: 1.6, textAlign: 'left' }}>
                            Are you sure you want to leave the player lineup for <strong>{act.actName}</strong>? You won't be part of any future gigs with this act.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ padding: '12px 20px 20px', gap: '12px' }}>
                        <Button 
                            onClick={this.handleCloseConfirmation} 
                            style={{ color: '#666', border: '1px solid #ddd', borderRadius: '6px', padding: '8px 20px', textTransform: 'none' }}
                        >
                            Stay
                        </Button>
                        <Button 
                            onClick={this.handleQuitAct} 
                            style={{ background: '#d32f2f', color: 'white', borderRadius: '6px', padding: '8px 24px', textTransform: 'none', fontWeight: 500 }}
                            autoFocus
                        >
                            Leave Act
                        </Button>
                    </DialogActions>
                </Dialog>
                <ConfirmationModal
                    open={this.state.duplicateConfirmationState}
                    message={`Are you sure you want to duplicate this act - ${act.actName}?`}
                    closeHandler={this.handleCloseConfirmation}
                    confirmationHandler={this.handleDupicateRequest}
                    declineHandler={this.handleCloseConfirmation}
                    confirmationLabel="Duplicate"
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                    }}
                    open={this.state.openDuplicateSnackbar}
                    autoHideDuration={4000}
                    onClose={this.handleSnackbarEditClose}
                    SnackbarContentProps={{
                        "aria-describedby": "message-id"
                    }}
                    message={<span id="message-id">Act {act.actName} duplicated</span>}
                    action={
                        <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleSnackbarEditClose}>
                            <CloseIcon />
                        </IconButton>
                    }
                />
            </Fragment>
        );
    }
}

export default ManagedActCard;
